export const LOCATE_WALLET_START = 'LOCATE_WALLET_START';
export const LOCATE_WALLET_SUCCESS = 'LOCATE_WALLET_SUCCESS';
export const LOCATE_WALLET_ERROR = 'LOCATE_WALLET_ERROR';
export const CLEAR_FOUND_WALLET = 'CLEAR_FOUND_WALLET';
